import "/src/App.scss?transform-only";export default "__VITE_CSS_URL__2f7372632f4170702e736373733f7472616e73666f726d2d6f6e6c79__"